<main class="home-shell">
  <div class="home-content-wrap">

    <!-- ── Pending Inventory Section ── -->
    <app-pending-inventory></app-pending-inventory>
    <!-- ── End Pending Inventory Section ── -->

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search inventory transactions</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by date, lot number, sales order..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Transactions Table -->
      <table mat-table [dataSource]="dataSource" matSort class="inventory-table">

        <!-- Created Column -->
        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.created | date:'short' }}</td>
        </ng-container>

        <!-- Created By Column -->
        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.createdBy || '-' }}</td>
        </ng-container>

        <!-- Inventory Transaction Type Column -->
        <ng-container matColumnDef="inventoryTransactionType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Transaction Type</th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.inventoryTransactionType || '-' }}</td>
        </ng-container>

        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
          <td mat-cell *matCellDef="let transaction">{{ transaction.quantity || '-' }}</td>
        </ng-container>

        <!-- Catalog Number Column -->
        <ng-container matColumnDef="catalogNum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Catalog #</th>
          <td mat-cell *matCellDef="let transaction">
            <a *ngIf="transaction.productId" class="link-cell" (click)="goToProduct(transaction.productId, $event)">{{ transaction.catalogNum || '-' }}</a>
            <span *ngIf="!transaction.productId">{{ transaction.catalogNum || '-' }}</span>
          </td>
        </ng-container>

        <!-- Lot Number Column -->
        <ng-container matColumnDef="lotNum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Lot Number</th>
          <td mat-cell *matCellDef="let transaction">
            <a *ngIf="transaction.productId" class="link-cell" (click)="goToProduct(transaction.productId, $event)">{{ transaction.lotNumNumber || '-' }}</a>
            <span *ngIf="!transaction.productId">{{ transaction.lotNumNumber || '-' }}</span>
          </td>
        </ng-container>

        <!-- Sales Order Column -->
        <ng-container matColumnDef="salesOrder">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Order</th>
          <td mat-cell *matCellDef="let transaction">
            <a *ngIf="transaction.salesOrderId" class="link-cell" (click)="goToSalesOrder(transaction.salesOrderId, $event)">{{ transaction.salesOrderNumber || '-' }}</a>
            <span *ngIf="!transaction.salesOrderId">-</span>
          </td>
        </ng-container>

        <!-- Purchase Order Column -->
        <ng-container matColumnDef="purchaseOrder">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Purchase Order</th>
          <td mat-cell *matCellDef="let transaction">
            <a *ngIf="transaction.purchaseOrderId" class="link-cell" (click)="goToPurchaseOrder(transaction.purchaseOrderId, $event)">{{ transaction.purchaseOrderNumber || '-' }}</a>
            <span *ngIf="!transaction.purchaseOrderId">-</span>
          </td>
        </ng-container>

        <!-- Invoice Column -->
        <ng-container matColumnDef="invoice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice</th>
          <td mat-cell *matCellDef="let transaction">
            <a *ngIf="transaction.invoiceId" class="link-cell" (click)="goToInvoice(transaction.invoiceId, $event)">{{ transaction.invoiceNumber || '-' }}</a>
            <span *ngIf="!transaction.invoiceId">-</span>
          </td>
        </ng-container>

         <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-inventory-transactions">
              <mat-icon>people</mat-icon>
              <p *ngIf="!input.value">No inventory transactions found.</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" [pageSize]="10" showFirstLastButtons
        aria-label="Select page of transactions">
      </mat-paginator>
    </div>

    <!-- ── Search ── -->
    <!-- <div class="home-search-wrap">
      <app-search [appearance]="'hero'" [placeholder]="'Search...'" [showButton]="false" [embedMode]="true"></app-search>
    </div> -->

    <!-- ── Inline Search Results ── -->
    <!-- <div class="search-results-wrap" *ngIf="searchQuery">

      <div *ngIf="searchLoading" class="search-state-message">
        <mat-spinner diameter="36"></mat-spinner>
        <p>Searching...</p>
      </div>

      <div *ngIf="searchError && !searchLoading" class="search-state-message search-error">
        <mat-icon color="warn">error_outline</mat-icon>
        <p>{{ searchError }}</p>
      </div>

      <ng-container *ngIf="!searchLoading && !searchError">
        <div *ngIf="totalCount === 0" class="search-state-message">
          <mat-icon>search_off</mat-icon>
          <p>No results found for <strong>"{{ searchQuery }}"</strong></p>
        </div>

        <div *ngIf="totalCount > 0">
          <p class="results-summary">
            Found <strong>{{ totalCount }}</strong> result{{ totalCount !== 1 ? 's' : '' }} for <strong>"{{ searchQuery }}"</strong>
          </p>

          <div *ngFor="let group of resultGroups" class="result-group">
            <div class="group-header">
              <mat-icon class="group-icon">{{ group.icon }}</mat-icon>
              <h3 class="group-label">{{ group.label }}</h3>
              <span class="group-count">{{ group.items.length }}</span>
              <button mat-button color="primary" class="view-all-btn" (click)="viewAll(group.route)" type="button">
                View All
              </button>
            </div>

            <mat-divider></mat-divider>

            <div class="result-list">
              <div *ngFor="let item of group.items"
                   class="result-item"
                   (click)="navigateTo(group.route, item.id)">
                <div class="result-item-content">
                  <span class="result-title">{{ item.title }}</span>
                  <span *ngIf="item.subtitle" class="result-subtitle">{{ item.subtitle }}</span>
                </div>
                <mat-chip *ngIf="item.status" class="status-chip" [class]="'status-' + (item.status | lowercase)">
                  {{ item.status }}
                </mat-chip>
                <mat-icon class="result-arrow">chevron_right</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div> -->
    <!-- ── End Inline Search Results ── -->

  </div>
</main>
